export default __webpack_public_path__ + "static/media/industrial.2f6b2e14.svg";